import axiosInstance from "../../axios/axiosInstance";
import { HOMEPAGE_CMS_DATA } from "../../constants";

export const getHomepageCmsData = (payload) => (onResponse) => {
  try {
    axiosInstance
      .post(HOMEPAGE_CMS_DATA, payload || {})
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {
    console.error('Homepage CMS data API call failed:', error);
  }
};
